import { STRIPE_TEST_PUBLISH_KEY } from '../../config/stripe'
import { isNullOrUndefined } from 'util'
import { CardInfo } from '../../types/CardInfo'

export default class Stripe {
    private _stripe: any
    constructor(stripe: any) {
        this._stripe = stripe
    }
    static getStripe(): Promise<Stripe> {
        return new Promise((resolve, reject) => {
            if (window.Stripe) {
                window.Stripe.setPublishableKey(STRIPE_TEST_PUBLISH_KEY)
                resolve(new Stripe(window.Stripe))
            } else {
                let script = document.querySelector('#stripe-js')
                if (script) {
                    script.addEventListener('load', () => {
                        window.Stripe.setPublishableKey(STRIPE_TEST_PUBLISH_KEY)
                        resolve(new Stripe(window.Stripe))
                    })
                } else {

                    reject('There is no stripe js')
                }
            }
        })
    }
    public createToken(card: CardInfo): Promise<any> {
        return new Promise((resolve, reject) => {
            this._stripe.card.createToken({
                address_country: card.country,
                currency: card.currency,
                number: card.cardNumber,
                exp_month: card.expireMonth,
                exp_year: card.expireYear,
                cvc: card.cvc,
                name: card.name
            }, (status, response) => {
                if (response.error) {
                    console.log('Stripe error', response.error.message)
                    reject(response.error)
                } else {
                    console.log('Stripe response', response)
                    resolve(response)
                }
            })
        })
    }
    public validateExpireDate(expMonth: number, expYear: number): boolean {
        return this._stripe.card.validateExpiry(expMonth, expYear)
    }
    public validateExpireDateStr(expire: string): boolean {
        return this._stripe.card.validateExpiry(expire)
    }

    public validateCvc(cvc: string): boolean {
        return this._stripe.card.validateCVC(cvc)
    }
    public validateCardNumber(cardNumber: string): boolean {
        return this._stripe.card.validateCardNumber(cardNumber)
    }
}



// WEBPACK FOOTER //
// ./src/services/stripe/stripe.ts